import localed9eab500 from '../../static/lang/ar-AR.js'
import locale6010b66b from '../../static/lang/en-US.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"ar"},
  vueI18nLoader: false,
  locales: [{"code":"ar","iso":"ar-AR","name":"Arabic","file":"ar-AR.js","dir":"rtl"},{"code":"en","iso":"en-US","name":"English","file":"en-US.js","dir":"ltr"}],
  defaultLocale: "ar",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix",
  lazy: false,
  langDir: "static/lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":true,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://www.motanamy.com",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  seo: true,
  normalizedLocales: [{"code":"ar","iso":"ar-AR","name":"Arabic","file":"ar-AR.js","dir":"rtl"},{"code":"en","iso":"en-US","name":"English","file":"en-US.js","dir":"ltr"}],
  localeCodes: ["ar","en"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "\"",
  2: "a",
  3: "r",
  4: "-",
  5: "A",
  6: "R",
  7: ".",
  8: "j",
  9: "s",
  10: "\"",
  11: ":",
  12: "\"",
  13: ".",
  14: ".",
  15: "/",
  16: "s",
  17: "t",
  18: "a",
  19: "t",
  20: "i",
  21: "c",
  22: "/",
  23: "l",
  24: "a",
  25: "n",
  26: "g",
  27: "/",
  28: "a",
  29: "r",
  30: "-",
  31: "A",
  32: "R",
  33: ".",
  34: "j",
  35: "s",
  36: "\"",
  37: ",",
  38: "\"",
  39: "e",
  40: "n",
  41: "-",
  42: "U",
  43: "S",
  44: ".",
  45: "j",
  46: "s",
  47: "\"",
  48: ":",
  49: "\"",
  50: ".",
  51: ".",
  52: "/",
  53: "s",
  54: "t",
  55: "a",
  56: "t",
  57: "i",
  58: "c",
  59: "/",
  60: "l",
  61: "a",
  62: "n",
  63: "g",
  64: "/",
  65: "e",
  66: "n",
  67: "-",
  68: "U",
  69: "S",
  70: ".",
  71: "j",
  72: "s",
  73: "\"",
  74: "}",
}

export const localeMessages = {
  'ar-AR.js': () => Promise.resolve(localed9eab500),
  'en-US.js': () => Promise.resolve(locale6010b66b),
}
